<template>
  <div class="row">
    <div
      v-bind:exams="exams"
      v-for="exam in exams"
      :key="exam.id"
      class="col-6"
    >
      <div class="tile tile--center u-no-padding">
        <div class="tile__container">
          <div class="row ignore-screen">
            <div class="col-9 ignore-screen">
              <div class="tile__title">
                <div>{{ exam.candidate.full_name }}</div>
              </div>
              <div class="tile__subtitle">
                {{ exam.title }}
              </div>
              <div class="info">
                <div class="tag-container u-no-margin">
                  <status-tag
                    v-bind:status="exam.result.status"
                    v-bind:label="exam.result.name"
                  ></status-tag>
                  <div class="tag tag--dark tag--large" v-if="exam.is_closed">
                    {{ getPercentageMark(exam) }}
                  </div>
                  <span v-if="exam.is_closed">
                    ({{ formatMarks(exam.marks_awarded) }} marks out of
                    {{ exam.marks_available }})
                  </span>
                </div>
                <span v-if="exam.supervisor">
                  Supervised by {{ exam.supervisor.full_name }}
                </span>
                <span v-if="exam.date"> on {{ formatDate(exam.date) }}</span>
              </div>
            </div>
            <div class="col-3 ignore-screen --list-table-action-button">
              <exam-action-button v-bind:exam="exam"></exam-action-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style></style>
<script>
import { DateFormatter } from "@/functions/dateFormat.function";
import ExamActionButton from "@/components/exams/ExamActionButton";
import StatusTag from "@/components/StatusTag";

export default {
  name: "exam-list",
  props: {
    exams: Array
  },
  components: {
    StatusTag,
    ExamActionButton
  },
  methods: {
    formatDate: function(dateString) {
      var result = DateFormatter(dateString);
      return result;
    },
    formatMarks: function(marks) {
      return Math.round(marks);
    },
    getPercentageMark(exam) {
      var result = (exam.marks_awarded / exam.marks_available) * 100;
      if (Number.parseInt(result) != result) {
        result = Number.parseFloat(result).toFixed(1);
      }
      if (result > 1000) {
        return "0 %";
      } else {
        return result + " %";
      }
    }
  }
};
</script>
